module.exports = __webpack_public_path__ + "img/turntable.6030e8ee.svg";